import {
  BooleanCriterionContent,
  CRITERION_TYPE,
  Criterion,
} from '@/store/types/criterions.types';

export function createDefaultCriterion(): Criterion {
  return new Criterion({
    content: new BooleanCriterionContent({
      title: '',
      type: CRITERION_TYPE.BOOLEAN,
      sourceLink: '',
    }),
  });
}
